module.exports = __webpack_public_path__ + "media/10-shi.3e64f7b8.mp3";